// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".symbol.user-avatar,.symbol.user-avatar .symbol-label{-webkit-transition:all .3s ease-out;transition:all .3s ease-out}.symbol.user-avatar:hover{-webkit-transform:scale(1.1);transform:scale(1.1)}", ""]);
// Exports
module.exports = exports;
